import React, { Fragment, PureComponent } from 'react'
import { Field } from 'redux-form'
import { Grid, IconButton, InputAdornment, CircularProgress } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import DeleteIcon from '@material-ui/icons/Delete'
import PersonIcon from '@material-ui/icons/Person'

import { required } from 'services/validations'
import { currencyMaker, convertCurrency } from 'services/helpers'
import { Input, Tooltip } from 'components'

export class PassengerFieldsBase extends PureComponent {
  render() {
    const { fields, classes, bookForm } = this.props
    const pax = {
      surname: bookForm.surname,
      name: bookForm.name,
      phone: bookForm.phone,
      price: bookForm.price
    }

    return (
      <Fragment>
        <Grid item xs={6}>
          {this.renderField('surname', 'Прізвище')}
        </Grid>
        <Grid item xs={6}>
          {this.renderField('name', 'Імя')}
        </Grid>
        <Grid item xs={6}>
          {this.renderField('phone', 'Телефон')}
        </Grid>
        <Grid item xs={5}>
          {this.renderField('price', 'Ціна')}
        </Grid>

        <Grid item xs={1} className={classes.icon}>
          <IconButton onClick={() => fields.push(pax)}>
            <AddIcon fontSize='small' />
          </IconButton>
        </Grid>

        {fields.map((member, index) => (
          <Fragment key={index}>
            <Grid item xs={6}>
              {this.renderField(`${member}.surname`, 'Прізвище')}
            </Grid>
            <Grid item xs={6}>
              {this.renderField(`${member}.name`, 'Імя')}
            </Grid>
            <Grid item xs={6}>
              {this.renderField(`${member}.phone`, 'Телефон')}
            </Grid>
            <Grid item xs={5}>
              {this.renderField(`${member}.price`, 'Ціна')}
            </Grid>
            <Grid item xs={1} className={classes.icon}>
              <IconButton onClick={() => fields.remove(index)}>
                <DeleteIcon fontSize='small' />
              </IconButton>
            </Grid>
          </Fragment>
        ))}
      </Fragment>
    )
  }

  getEndAdorment = (label) => {
    /* eslint-disable */
    switch (label) {
      case 'Ціна':
        return {
          endAdornment: this.renderPriceAdornment(),
        }
      case 'Телефон':
        return {
          endAdornment: this.renderPhoneAdornment(),
        }
      default:
        return null
    }
    /* eslint-enable */
  }

  getPersonIconClass = () => !!this.props.bookingsBlacklistLength
    ? this.props.classes.redIcon
    : this.props.classes.greenIcon

  onPersonIconClick = () => {
    this.props.showModal({ type: 'passengerInfo' })
  }

  handleOnBlur = name => () => {
    if (name !== 'phone') {
      return
    }
    this.props.getPassenger()
  }

  handlePassengerTooltipTitle = () => {
    switch (this.props.bookingsLength) {
    case 1 || 2 || 3 || 4:
      return `${this.props.bookingsLength} бронювання`
    default:
      return `${this.props.bookingsLength} бронювань`
    }
  }

  renderProgress = () =>
    this.props.isLoading && (
      <InputAdornment position='end'>
        <IconButton>
          <CircularProgress size={20} />
        </IconButton>
      </InputAdornment>
    )

  renderPassengerIcon = () =>
    !!this.props.bookingsLength && !this.props.isLoading && (
      <InputAdornment position='end'>
        <Tooltip
          placement='top'
          title={this.handlePassengerTooltipTitle()}
        >
          <IconButton onClick={this.onPersonIconClick}>
            <PersonIcon className={this.getPersonIconClass()} />
          </IconButton>
        </Tooltip>
      </InputAdornment>
    )

  renderPhoneAdornment = () => (
    <Fragment>
      {this.renderProgress()}
      {this.renderPassengerIcon()}
    </Fragment>
  )

  renderPriceAdornment = () => {
    const { bookForm: { price }, fromCityType } = this.props
    const currency = currencyMaker(fromCityType, price)
    const convertedCurrency = convertCurrency(price, currency)
    const priceTooltipTitle = convertedCurrency
      ? `${convertedCurrency} грн.`
      : ''

    return (
      <InputAdornment position='end'>
        <Tooltip title={priceTooltipTitle} placement='top'>
          <div>
            {currency}
          </div>
        </Tooltip>
      </InputAdornment>
    )
  }

  renderField = (name, label) => (
    <Field
      name={name}
      component={Input}
      label={label}
      validate={required}
      fullWidth
      required
      margin='normal'
      onBlur={this.handleOnBlur(name)}
      InputProps={this.getEndAdorment(label)}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/PassengerFields/PassengerFields.js